import { call, put, takeEvery } from "redux-saga/effects";

import { responseHandler } from "common/CommanFunction";

import {
  ADD_CONTRACTOR,
  ADD_SERVICE,
  ADD_VISITOR,
  CONTRACTOR_LIST,
  CONTRACTOR_STATUS,
  REMOVE_VISITOR_FILE,
  SERVICE_LIST,
  UPDATE_CONTRACTOR,
  UPDATE_LOCATION,
  UPDATE_SERVICE,
  UPDATE_VISITOR,
  VISITOR_LIST,
} from "./actionTypes";
import {
  addContractorFail,
  addContractorSuccess,
  addLocationServiceFail,
  addLocationServiceSuccess,
  addVisitorFail,
  addVisitorSuccess,
  contractorListFail,
  contractorListSuccess,
  contractorStatusFail,
  contractorStatusSuccess,
  locationServiceListFail,
  locationServiceListSuccess,
  removeVisitorFileFail,
  removeVisitorFileSuccess,
  updateContractorFail,
  updateContractorSuccess,
  updateLocationFail,
  updateLocationServiceFail,
  updateLocationServiceSuccess,
  updateLocationSuccess,
  updateVisitorFail,
  updateVisitorSuccess,
  visitorListFail,
  visitorListSuccess,
} from "./actions";
import {
  onAddingVisitor,
  onGettingVisitor,
  onGettingContractorList,
  onAddingContractor,
  onGettingLocationService,
  onAddingLocationService,
  onUpdatingVisitor,
  onRemovingVisitorFile,
  onChangingContractorStatus,
  onUpdatingContractor,
  onUpdatingService,
  onUpdatingUpdating,
} from "helpers/fakebackend_helper";

function* onAddVisitor({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingVisitor, data);
    yield call(responseHandler, "Visitor", response, addVisitorSuccess, addVisitorFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(addVisitorFail(error));
  }
}

function* onUpdateVisitor({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingVisitor, data);
    yield call(responseHandler, "Visitor", response, updateVisitorSuccess, updateVisitorFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(updateVisitorFail(error));
  }
}

function* onGetVisitor({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingVisitor, data);
    yield call(responseHandler, "Visitor", response, visitorListSuccess, visitorListFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(visitorListFail(error));
  }
}

function* onGetService({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingLocationService, data);
    yield call(responseHandler, "Location Service", response, locationServiceListSuccess, locationServiceListFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(locationServiceListFail(error));
  }
}

function* onAddService({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingLocationService, data);
    yield call(responseHandler, "Location Service", response, addLocationServiceSuccess, addLocationServiceFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(addLocationServiceFail(error));
  }
}

function* onGetContractorList({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingContractorList, data);
    yield call(responseHandler, "Contractor", response, contractorListSuccess, contractorListFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(contractorListFail(error));
  }
}

function* onAddContractor({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingContractor, data);
    yield call(responseHandler, "Contractor", response, addContractorSuccess, addContractorFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(addContractorFail(error));
  }
}

function* onUpdateContractor({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingContractor, data);
    yield call(responseHandler, "Contractor", response, updateContractorSuccess, updateContractorFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(updateContractorFail(error));
  }
}

function* onRemoveVisitorFile({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onRemovingVisitorFile, data);
    yield call(responseHandler, "Contractor", response, removeVisitorFileSuccess, removeVisitorFileFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(removeVisitorFileFail(error));
  }
}

function* onChangeContractorStatus({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onChangingContractorStatus, data);
    yield call(responseHandler, "Contractor", response, contractorStatusSuccess, contractorStatusFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(contractorStatusFail(error));
  }
}

function* onUpdateService({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingService, data);
    yield call(responseHandler, "Contractor", response, updateLocationServiceSuccess, updateLocationServiceFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(updateLocationServiceFail(error));
  }
}

function* onUpdateLocation({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingUpdating, data);
    yield call(responseHandler, "Location", response, updateLocationSuccess, updateLocationFail, onSuccess, onError);
  } catch (error) {
    onError(error);
    yield put(updateLocationFail(error));
  }
}

function* LocationSaga() {
  yield takeEvery(UPDATE_LOCATION, onUpdateLocation);
  yield takeEvery(ADD_VISITOR, onAddVisitor);
  yield takeEvery(UPDATE_VISITOR, onUpdateVisitor);
  yield takeEvery(VISITOR_LIST, onGetVisitor);
  yield takeEvery(SERVICE_LIST, onGetService);
  yield takeEvery(ADD_SERVICE, onAddService);
  yield takeEvery(CONTRACTOR_LIST, onGetContractorList);
  yield takeEvery(ADD_CONTRACTOR, onAddContractor);
  yield takeEvery(REMOVE_VISITOR_FILE, onRemoveVisitorFile);
  yield takeEvery(CONTRACTOR_STATUS, onChangeContractorStatus);
  yield takeEvery(UPDATE_CONTRACTOR, onUpdateContractor);
  yield takeEvery(UPDATE_SERVICE, onUpdateService);
}

export default LocationSaga;
